import { ComponentProps, FunctionComponent } from 'react';

import { castTo } from '../../../shared/utils/cast-to';
import { WithFormStateProps } from '../../../shared/utils/higher-order-functions/with-releases-layout/models/with-form-state-props.model';
import { WithReleasesLayoutPropsModel } from '../../../shared/utils/higher-order-functions/with-releases-layout/models/with-releases-layout-props.model';
import { withReleasesLayout } from '../../../shared/utils/higher-order-functions/with-releases-layout/with-create-releases-layout.hoc';
import { useIsExceptedApp } from '../../hooks/use-find-app-name-by-app-id-from-release.hook';
import ReleasesForm from '../ReleasesForm/ReleasesForm';
import ReleasesTable from '../ReleasesTable/ReleasesTable';
import ExceptedAppsReleaseFormWrapped from '../excepted-apps-release-form/excepted-apps-release-form';

type FormProps = ComponentProps<typeof ReleasesForm>;
type TableProps = ComponentProps<typeof ReleasesTable> & WithFormStateProps;

const ExceptedAppRelease = castTo<FunctionComponent<FormProps>>(
  ExceptedAppsReleaseFormWrapped
);

const ReleasesLayoutWrapper: FunctionComponent<
  WithReleasesLayoutPropsModel<TableProps, FormProps>
> = props => {
  const isExceptedApp = useIsExceptedApp();

  const ReleasesFormComponent: FunctionComponent<FormProps> = isExceptedApp
    ? ExceptedAppRelease
    : ReleasesForm;

  const ReleasesLayout = withReleasesLayout<FormProps, TableProps>(
    ReleasesTable
  )(ReleasesFormComponent);

  return <ReleasesLayout {...props} />;
};

export default ReleasesLayoutWrapper;
